// export const BASE_URL = "https://meterpro-staging.azurewebsites.net";
// export const BASE_URL = "https://meterproapi.azurewebsites.net";

export const AUTH_URL = "https://nano-passport-120179026248.us-central1.run.app";

export const BASE_URL = "https://tango-data-api-120179026248.us-central1.run.app";

export const GLOBAL_BASE_URL = "https://meterproapi.azurewebsites.net";

export const BACK_OFFICE_URL = "https://back-office-service-api-120179026248.us-central1.run.app";

export const METER_CMD_URL = "https://meter-cmd-api-120179026248.us-central1.run.app";

export const PAYMENT_URL = "https://payment-service-api-120179026248.us-central1.run.app";

export const SCHEDULER_URL = "https://scheduler-service-api-120179026248.us-central1.run.app";

export const RESIDENCE_URL = "https://residence.meterpromax.com";

export const ENTERPRISE_URL = "https://enterprise.meterpromax.com";

export const CONTROL_CENTER_URL = "https://control-center.meterpromax.com";

export const FACILITY_MGT_URL = "https://facility-management.meterpromax.com";

export const BILLING_URL = "https://billing-service-120179026248.us-central1.run.app";

export const GUEST_MGT_URL = "https://guest-management-api-120179026248.us-central1.run.app";

